import { cn } from '@ui/lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'
import { forwardRef } from 'react'

const headingVariants = cva('font-bold text-gray-900', {
  variants: {
    size: {
      xl: 'text-3xl md:text-4xl',
      lg: 'text-2xl md:text-3xl',
      md: 'text-xl md:text-2xl',
      sm: 'text-lg md:text-xl',
      xs: 'text-base md:text-lg',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export interface HeadingProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
  VariantProps<typeof headingVariants> {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ as: Component = 'h2', size, className, children, ...props }, ref) => {
    return (
      <Component ref={ref} className={cn(headingVariants({ size, className }))} {...props}>
        {children}
      </Component>
    )
  }
)

Heading.displayName = 'Heading'
